
import brand from '../../brandConfig'
import { useEffect, useLayoutEffect, useState } from "react"
import { createPortal } from "react-dom"
import { Link, useNavigate } from 'react-router-dom'
import { PhoneCall } from 'lucide-react'
import { appConfig } from '../../appConfig'
import Bars from '../../assets/images/bars.svg'
import SkyriseLogo from '../../assets/images/logo.png'
import Service from '../../Service/Service'
import ContactForm from '../Contact/ContactForm'

const PHONE_NUMBER = '02081949506'



const NAVBAR_PORTAL_ID = 'navbar-fixed-portal'

const Navbar = props => {

    const headRoute = appConfig.headRoute

    const [viewMenu, setViewMenu] = useState(false)
    const [categories, setCategories] = useState([])
    const [tabindex, setTabIndex] = useState(1)
    const [portalEl, setPortalEl] = useState(null)

    const navigate = useNavigate()

    const getCategories = () => {

        Service.getAllCategory().then(response => {

            setCategories(response.data)
        })
    }

    useEffect(() => {
        getCategories();
    }, [])

    // Create a dedicated fixed container as first child of body so header never scrolls
    useLayoutEffect(() => {
        let el = document.getElementById(NAVBAR_PORTAL_ID)
        if (!el) {
            el = document.createElement('div')
            el.id = NAVBAR_PORTAL_ID
            el.style.setProperty('position', 'fixed', 'important')
            el.style.setProperty('top', '0', 'important')
            el.style.setProperty('left', '0', 'important')
            el.style.setProperty('right', '0', 'important')
            el.style.setProperty('z-index', '9999', 'important')
            document.body.insertBefore(el, document.body.firstChild)
        }
        setPortalEl(el)
    }, [])

    // Prevent background scrolling when mobile menu is open
    useEffect(() => {
        if (viewMenu) {
            const prevBodyOverflow = document.body.style.overflow;
            const prevHtmlOverflow = document.documentElement.style.overflow;

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            return () => {
                document.body.style.overflow = prevBodyOverflow || '';
                document.documentElement.style.overflow = prevHtmlOverflow || '';
            };
        } else {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        }
    }, [viewMenu])

    const url = window.location.pathname
    const isHomePage = url === '/' || url === (headRoute || '') || url === `${headRoute || ''}/`
    const isFlightSearchPage = url.includes('flight-detail-search')
    console.log(' %% URL : ', url)

    // Determine background color
    let bgClass = 'bg-transparent';
    if (props.bg === 'blue') {
        bgClass = 'bg-secondary';
    } else if (props.bg) {
        bgClass = 'bg-secondary';
    }
    // On flight search page use red header on desktop too
    if (isFlightSearchPage && props.bg) {
        bgClass = 'bg-secondary';
    }
    const solidBgOnDesktop = isFlightSearchPage;

    const navbarEl = (
        <div data-navbar-root className={`${bgClass} ${solidBgOnDesktop ? '' : 'md:bg-transparent'} fixed top-0 left-0 right-0 w-full z-50 h-24 min-h-24 ${isHomePage ? 'md:pointer-events-none' : ''}`}>
            <DialogueContactUs />
            {/* Desktop: on home page hide header bar (logo/links are in banner); on other pages show it */}
            <div className={isHomePage ? 'md:hidden' : ''}>
            {/* <div className='navTopSection h-[40px] items-center px-14 border-b border-b-white hidden lg-1:flex'>
                         <div className='flex gap-8 text-xs font-normal text-white'>
                             <p>
                                 support@skysale.co.uk
                             </p>
                             <p>
                                 073-082-327-84
                             </p>
                             <p>
                             38 Hertford Street, London, England, W1J 7SG
                             </p>
                         </div>
                     </div> */}

            <div className="navbar w-full md:w-[85%] mx-auto md:bg-transparent">

                <div className="navbar-start ml-0 px-0  w-full lg-1:w-1/5">
                    <Link
                        className="btn btn-ghost normal-case text-xl p-0 md:px-1"
                    >
                        {/* {
                        url=='/'? */}
                        {/* <div className='logo'>
                            
                            <img src={LogoDark} className='w-[200px]'/>
                            
                        </div> */}
                        <div className='logo -mt-1.5 ml-1 flex items-center' role='button' onClick={() => { navigate(`/`) }}>
                            <img src={SkyriseLogo} alt="SkyRise Travels" className='hidden md:block h-24 w-auto object-contain' />
                            <span className='md:hidden font-extrabold text-2xl tracking-tight'>
                                <span className='text-[#00B4D8]'>Sky</span><span className='text-white'>Rise Travels</span>
                            </span>
                        </div>

                    </Link>
                </div>
                <div className="navbar-center hidden gap-3 lg-1:flex">

                    {/* <div className="dropdown dropdown-hover ">
                    <label tabIndex={0} className="cursor-pointer m-1 text-white tracking-[1px] leading-7">Pages</label>
                    <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-black text-white w-52">
                        <li >
                            <Link className='bg-transparent font-poppins tracking-[2px]' to={'/about'}>
                                ABOUT US 
                            </Link>
                        </li>
                        <li >
                            <Link 
                        className='bg-transparent font-poppins tracking-[2px]'
                        to={`${headRoute}/contact`}
                        >
                            CONTACT US
                        </Link>
                    </li>
                    </ul>
                </div> */}
                    <button type="button" className='bg-transparent font-poppins tracking-[2px] text-white tracking-[1px] leading-7 cursor-pointer hover:opacity-80' onClick={() => { navigate('/') }}>
                        Flights
                    </button>

                    {/* <div className="dropdown dropdown-hover">
  <label tabIndex={0} className="cursor-pointer m-1 text-white tracking-[1px] leading-7">Holidays</label>
  <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-primary rounded-box w-52">
  {
                                    categories.map(x=>{
                                        return <Link className='bg-transparent font-poppins tracking-[2px]' to={`/allpackages?category=${x.uid}&type=holiday`}>
                                        <li className='p-2'>{x.name}</li>
                                    </Link>
                                        

                                    })
                                }
    
    
  </ul>
</div> */}



                    {/* <div className="dropdown dropdown-hover">
  <label tabIndex={0} className="cursor-pointer m-1 text-white tracking-[1px] leading-7">Umrah Packages</label>
  <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-primary rounded-box w-52">
  {
                                    categories.map(x=>{
                                        return <Link className='bg-transparent font-poppins tracking-[2px]' to={`/allpackages?category=${x.uid}&type=umrah`}>
                                        <li className='p-2'>{x.name}</li>
                                    </Link>
                                        

                                    })
                                }
    
    
  </ul>
</div> */}


                    {/* <details>
          <summary tabIndex={0}>Parent</summary>
          <ul className="p-2">
          
          </ul>
        </details>
       */}



                    {/* <Link className='bg-transparent font-poppins tracking-[2px]' role='button' onClick={()=>{ navigate(`/umrahvisa`)}}>
                <label  className="cursor-pointer m-1 text-white tracking-[1px] leading-7">Umrah Visa</label>
                            </Link> */}


                    <button type="button" className='bg-transparent font-poppins tracking-[2px] text-white tracking-[1px] leading-7 cursor-pointer hover:opacity-80' onClick={() => { document.getElementById('my_modal_contact').showModal() }}>
                        Contact Us
                    </button>
                    {/* <Link className='bg-transparent font-poppins tracking-[2px]' to={'/aboutus'}>
                <label  className="cursor-pointer m-1 text-white tracking-[1px] leading-7">About Us</label>
                            </Link> */}

                </div>





                {/* Phone at far right on desktop; hamburger on mobile */}
                <div className="navbar-end flex items-center gap-2">
                    <a
                        href={`tel:${PHONE_NUMBER}`}
                        className="hidden lg-1:flex items-center gap-2 cursor-pointer hover:opacity-90"
                        aria-label="Call us"
                    >
                        <div className="bg-white/20 p-1.5 rounded-full">
                            <PhoneCall className="text-white w-4 h-4" />
                        </div>
                        <div className="flex flex-col leading-tight">
                            <span className="text-[10px] text-white/80 font-medium tracking-wide">Call Us Now</span>
                            <span className="text-sm font-bold text-white tracking-wide">{PHONE_NUMBER}</span>
                        </div>
                    </a>
                    {/* Hamburger button - mobile only */}
                    <button
                        type="button"
                        aria-label="Open navigation menu"
                        className="btn btn-ghost rounded-full p-1 lg-1:hidden"
                        onClick={() => setViewMenu(true)}
                    >
                        <img src={Bars} height="28" width="28" alt="Menu" />
                    </button>

                    {/* Full-screen mobile menu overlay */}
                    {viewMenu && (
                        <div className="fixed inset-0 z-[100]">
                            {/* Backdrop */}
                            <div
                                className="absolute inset-0 bg-black/60 backdrop-blur-sm"
                                onClick={() => setViewMenu(false)}
                                aria-hidden="true"
                            />

                            {/* Slide-in panel - dark */}
                            <div className="absolute top-0 right-0 h-full w-4/5 max-w-xs bg-navy-900 text-white shadow-2xl flex flex-col py-5 px-5 animate-slide-in-right">
                                {/* Close button left, logo right - same row */}
                                <div className="flex items-center justify-between mb-4">
                                    <button
                                        type="button"
                                        aria-label="Close navigation menu"
                                        className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition shrink-0"
                                        onClick={() => setViewMenu(false)}
                                    >
                                        <span className="text-2xl leading-none">&times;</span>
                                    </button>
                                    <span
                                        className="cursor-pointer"
                                        role="button"
                                        onClick={() => { setViewMenu(false); navigate('/'); }}
                                    >
                                        <span className='font-extrabold text-2xl tracking-tight'>
                                            <span className='text-[#00B4D8]'>Sky</span><span className='text-white'>Rise Travels</span>
                                        </span>
                                    </span>
                                </div>

                                {/* Links - at top of menu, right-aligned */}
                                <nav className="flex flex-col gap-3 text-base font-medium items-end">
                                    <button
                                        type="button"
                                        className="text-right px-3 py-2 rounded-xl hover:bg-white/10 transition w-full flex justify-end text-white"
                                        onClick={() => {
                                            setViewMenu(false);
                                            navigate('/');
                                        }}
                                    >
                                        <span>Flights</span>
                                    </button>

                                    <button
                                        type="button"
                                        className="text-right px-3 py-2 rounded-xl hover:bg-white/10 transition w-full flex justify-end text-white"
                                        onClick={() => {
                                            setViewMenu(false);
                                            document.getElementById('my_modal_contact').showModal();
                                        }}
                                    >
                                        <span>Contact Us</span>
                                    </button>
                                </nav>

                                {/* Spacer */}
                                <div className="flex-1 min-h-4" />

                                {/* Bottom CTA */}
                                <div className="mt-4 pt-4 border-t border-white/20 text-xs text-gray-300">
                                    <p className="font-semibold text-white mb-1">Need help?</p>
                                    <p>Our team is available to help you find the best flights and packages.</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            </div>
        </div>
    );
    if (!portalEl) return null
    return createPortal(navbarEl, portalEl)
        // <div className='absolute z-10 top-0 left-0 w-full font-poppins'>

        //     <div 
        //     className={`
        //         nav 
        //         ${
        //             url!='/'?
        //             'bg-white lg-1:bg-transparent':'bg-transparent'
        //         }
        //     `}
        //     >

        //         {
        //             url!='/'?
        //             <div className='navTopSection h-[40px] items-center px-14 border-b border-b-white hidden lg-1:flex'>
        //                 <div className='flex gap-8 text-xs font-normal text-white'>
        //                     <p>
        //                         valiance@qodeinteractive.com
        //                     </p>
        //                     <p>
        //                         073-082-327-84
        //                     </p>
        //                     <p>
        //                         Maria-Theresien-Platz, 1010 Wien
        //                     </p>
        //                 </div>
        //             </div>:''
        //         }
        //         <div className='logoSection py-9 px-14 flex gap-12'>

        //             {
        //                 url=='/'?
        //                 <div className='logo'>

        //                     <img src={LogoDark} className='w-[200px]'/>

        //                 </div>:
        //                 <div className='logo'>
        //                     <img src={LogoWhite} className='w-[200px] hidden lg-1:block'/>
        //                     <img src={LogoDark} className='w-[200px] block lg-1:hidden'/>
        //                 </div>
        //             }
        //             <div>

        //                 <div  className='hidden lg-1:flex flex-column lg-1:flex-row gap-11'>
        //                     <div className="dropdown dropdown-hover">
        //                         <label tabIndex={0} className="cursor-pointer m-1">Home</label>
        //                         <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-black text-white w-52">
        //                             <li >
        //                                 <Link className='font-poppins tracking-[2px]'>
        //                                     MAIN HOME
        //                                 </Link>
        //                             </li>
        //                             <li >
        //                                 <Link className='font-poppins tracking-[2px]'>
        //                                     CONSULTING HOME
        //                                 </Link>
        //                             </li>
        //                         </ul>
        //                     </div>

        //                     <div className="dropdown dropdown-hover">
        //                         <label tabIndex={0} className="cursor-pointer m-1">Pages</label>
        //                         <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-black text-white w-52">
        //                             <li >
        //                                 <Link className='bg-transparent font-poppins tracking-[2px]'>
        //                                     ABOUT US 
        //                                 </Link>
        //                             </li>
        //                             <li >
        //                                 <Link 
        //                                 className='bg-transparent font-poppins tracking-[2px]'
        //                                 to={`${headRoute}/contact`}
        //                                 >
        //                                     CONTACT US
        //                                 </Link>
        //                             </li>
        //                         </ul>
        //                     </div>

        //                 </div>


        //             </div>

        //         </div>
        //     </div>

        // </div>
}

const DialogueContactUs = () => {
    return (
        <dialog id="my_modal_contact" className="modal backdrop-blur-sm">
            <div className="modal-box w-11/12 max-w-4xl max-h-[90vh] bg-white rounded-2xl shadow-2xl p-0 overflow-hidden flex flex-col">
                <form method="dialog">
                    {/* if there is a button in form, it will close the modal */}
                    <button className="btn btn-sm btn-circle btn-ghost absolute right-4 top-4 text-gray-600 hover:bg-gray-100 z-10">✕</button>
                </form>
                <div className="flex-1 overflow-y-auto">
                    <ContactForm />
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button>close</button>
            </form>
        </dialog>
    )
}
export default Navbar